export default __webpack_public_path__ + "static/media/RetinSight-BG-People.2415df74.jpg";